module.exports = __webpack_public_path__ + "static/8Bugeon-a6e2ca4aceba520bf9c46661b05dc3ac.jpg";